// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global sliceweekly, FWP, wp, handorgel, Fancybox */

(function ($) {
  const wntrTheme = {
    body: $('body'),
    html: $('html'),
    header: $('header'),
    document: $(document),

    /**
     * Initialise theme JS on page load
     */
    init: function () {
      // Do we have JS?
      $('html').removeClass('no-js');

      // Automatically call all methods that start with __, in the order they're defined
      for (const prop in wntrTheme) {
        if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
          wntrTheme[prop].call();
        }
      }
    },

    __autoCheckRememberMe: () => {
      $(document).ready(function () {
        const $rememberMe = $('.gfield--type-remember_me #choice_3');
        if ($rememberMe.length > 0) {
          $rememberMe.prop('checked', true);
        }
      });
    },

    /**
     * Login modal
     */
    __loginModal: () => {
      wntrTheme.body.on('click', '#login-form-modal input[type="submit"]', function() {
        const $btn = $(this);
        $btn.closest('.gform_footer').addClass('loading');
      });
    },

    /**
     * Toggle promo code
     */
    __togglePromocode: () => {
      wntrTheme.body.on('keypress', '.gf_coupon_code', function (e) {
        const key = e.which;
        if(key === 13) {
          e.preventDefault();
          wntrTheme.body.find('#gf_coupon_button').trigger('click');
        }
      });
    },

    /**
     * Reload page when changing facet cat
     */
    __reloadPageOnExerciseSelect: () => {
      setTimeout(() => {
        const $exerciseRadios = wntrTheme.body.find('.facetwp-facet-exercise .facetwp-radio');
        if($exerciseRadios.length > 0) {
          $.each($exerciseRadios, function() {
            $(this).removeClass('facetwp-radio').addClass('facetwp-radio-altered');
          });
        }
      }, 50);

      wntrTheme.body.on('click', '.facetwp-facet-exercise .facetwp-radio-altered', function() {
        const url = location.protocol + '//' + location.host + location.pathname;
        window.location.href = url + '?_exercise=' + $(this).data('value');
      });
    },

    /**
     * Reload page when changing facet cat
     */
    __reloadPageOnRecipeSelect: () => {
      setTimeout(() => {
        const $recipeRadios = wntrTheme.body.find('.facetwp-facet-recipe .facetwp-radio');
        if($recipeRadios.length > 0) {
          $.each($recipeRadios, function() {
            $(this).removeClass('facetwp-radio').addClass('facetwp-radio-altered');
          });
        }
      }, 50);

      wntrTheme.body.on('click', '.facetwp-facet-recipe .facetwp-radio-altered', function() {
        const url = location.protocol + '//' + location.host + location.pathname;
        window.location.href = url + '?_recipe=' + $(this).data('value');
      });
    },

    /**
     * Count num posts if showing saved posts
     */
    __numSavedPosts: () => {
      const url = new URL(window.location.href);
      if (url.searchParams.has('saved')) {
        setTimeout(() => {
          const $posts = wntrTheme.body.find('.archive__posts .slide');
          const $count = wntrTheme.body.find('.facetwp-counts');
          if($posts.length > 0 && $count.length > 0) {
            const $count_words_arr = $count.text().match(/\b(\w+)\b/g);
            $count_words_arr[0] = $posts.length.toString();

            $count.html($count_words_arr.join(' '));
          }
        }, 50);
      }
    },

    /**
     * Custom like function
     */
    __likePost: () => {
      wntrTheme.body.on('click', '.slide__like', function (e) {
        e.preventDefault();
        const $btn = $(this);

        const data = {
          action: 'handle_likes',
          data: {
            user_id: $btn.data('id'),
            post_id: $btn.data('post-id'),
            post_type: $btn.data('post-type')
          },
        };

        $.ajax({
          url: sliceweekly.ajax_url,
          data: data,
          type: 'POST',
          dataType: 'json',
          beforeSend: function() {
            $btn.prop('disabled', true);
          },
          complete: function (res) {
            const $likesEl = $btn.find('.slide__like-num');
            const likes = parseInt($likesEl.text());

            if(res.responseJSON.data.message === 'liked') {
              $likesEl.html(likes + 1);
              $btn.addClass('liked');
            } else {
              $likesEl.html(likes - 1);
              $btn.removeClass('liked');
            }

            if(res.responseJSON.data.has_saved_exercises) {
              wntrTheme.body.find('.archive__filter-categories-show-all--exercise').removeClass('archive__filter--hidden');
              wntrTheme.body.find('.header__extras-links-menu-item--exercise').removeClass('header__extras-links-menu-item--hidden');
            } else {
              wntrTheme.body.find('.archive__filter-categories-show-all--exercise').addClass('archive__filter--hidden');
              wntrTheme.body.find('.header__extras-links-menu-item--exercise').addClass('header__extras-links-menu-item--hidden');
            }

            if(res.responseJSON.data.has_saved_recipes) {
              wntrTheme.body.find('.archive__filter-categories-show-all--recipe').removeClass('archive__filter--hidden');
              wntrTheme.body.find('.header__extras-links-menu-item--recipe').removeClass('header__extras-links-menu-item--hidden');
            } else {
              wntrTheme.body.find('.archive__filter-categories-show-all--recipe').addClass('archive__filter--hidden');
              wntrTheme.body.find('.header__extras-links-menu-item--recipe').addClass('header__extras-links-menu-item--hidden');
            }

            if(wntrTheme.body.find('.header__extras-top a') && wntrTheme.body.find('.header__extras-top a.header__extras-links-menu-item--hidden').length == 1) {
              wntrTheme.body.find('.header__extras-top').addClass('header__extras-top--1');
            } else {
              wntrTheme.body.find('.header__extras-top').removeClass('header__extras-top--1');
            }

            $btn.prop('disabled', false);
          },
        });
      });
    },

    /**
     * Custom reset password form
     */
    __modalResetPassword: () => {
      wntrTheme.body.on('submit', '#lost-password-modal form', function (e) {
        e.preventDefault();
        const $form = $(this);
        const user_login = $form.find('#lost_password').val();

        if (user_login.length > 0) {
          $form.find('.gfield').removeClass('gfield_error');
          $form.find('.validation_message').remove();

          const data = {
            action: 'handle_lost_password',
            data: {
              user_login: user_login,
            },
          };

          $.ajax({
            url: sliceweekly.ajax_url,
            data: data,
            type: 'POST',
            dataType: 'json',
            beforeSend: function () {
              $form.addClass('loading');
            },
            success: function (response) {
              renderMessage(response.data.message, response.success);
            },
            fail: function () {
              renderMessage('Någonting gick fel, försök igen.', true);
            },
            complete: function () {
              $form.removeClass('loading');
            },
          });
        } else if (!$form.find('.gfield').hasClass('gfield_error')) {
          $form.find('.gfield').addClass('gfield_error');
          $form
            .find('.gfield')
            .append(
              '<div class="gfield_description validation_message gfield_validation_message">Fältet är obligatoriskt.</div>'
            );
        }
      });

      function renderMessage(msg, isSuccess) {
        wntrTheme.body.find('#lost-password-modal .lost-password__message').remove();
        wntrTheme.body
          .find('#lost-password-modal .gform_wrapper--custom')
          .prepend(
            '<div class="lost-password__message lost-password__message--' +
              (isSuccess ? 'success' : 'error') +
              '">' +
              msg +
              '</div>'
          );
      }
    },

    /**
     * Toggle account fields
     */
    __toggleAccountFields: () => {
      const $account_form = wntrTheme.body.find('.account-settings__form');
      if ($account_form.length > 0) {
        const $account_form_inputs = $account_form.find('.gfield');

        $.each($account_form_inputs, function () {
          if ($(this).hasClass('customer-password')) {
            $(this).append(
              '<span class="account-settings__edit-divider">/</span><a class="account-settings__edit-password" data-fancybox="lost-password" data-src="#lost-password-modal">Ändra*</a>'
            );
          } else if(!$(this).hasClass('customer-email')) {
            $(this).append(
              '<span class="account-settings__edit-divider">/</span><button type="button" class="btn--clean account-settings__edit-row">Ändra*</button>'
            );
          }
        });
      }

      wntrTheme.body.on('click', '.account-settings__edit-row', function () {
        const $btn = $(this);
        const $input_wrapper = $btn.closest('.gfield');
        const $input = $input_wrapper.find('input');
        if ($input_wrapper.hasClass('gfield--editable')) {
          $btn.closest('form').find('input[type=submit]').trigger('click');
        }

        $input_wrapper.addClass('gfield--editable');
        $btn.text('Spara');

        // Since it's text align right, we want to focus end of input
        $input.focus();
        const val = $input.val();
        $input.val('');
        $input.val(val);
      });
    },

    /**
     * Toggle account settings
     */
    __toggleAccountSettings: () => {
      const $accordion_settings = wntrTheme.body.find('.header__extras-links--logged-in-desktop');

      wntrTheme.body.find('.header__extras-logged-in-avatar').on('click', function () {
        $accordion_settings.toggleClass('header__extras-links-desktop-menu--active');
      });

      wntrTheme.body.find('.header__extras-links-desktop-menu-overlay').on('click', function () {
        $accordion_settings.removeClass('header__extras-links-desktop-menu--active');
      });

      $(document).on('keyup', function (e) {
        if (e.key == 'Escape') {
          $accordion_settings.removeClass('header__extras-links-desktop-menu--active');
        }
      });
    },

    /**
     * Fancybox settings
     */
    __fancyboxSettings: () => {
      Fancybox.defaults.dragToClose = false;
      Fancybox.defaults.animated = false;

      // Open login form modal from lost password modal
      wntrTheme.body.find('.lost-password-modal__back-button').on('click', function (e) {
        e.preventDefault();
        Fancybox.close();
        Fancybox.show([{ src: '#login-form-modal' }]);
        history.pushState({}, null, window.location.href.split('#')[0] + '#login');
      });

      // Open lost password modal from login form modal
      wntrTheme.body.find('.gf_login_links--lost-password').on('click', function (e) {
        e.preventDefault();
        Fancybox.close();
        Fancybox.show([{ src: '#lost-password-modal' }]);
        history.pushState({}, null, window.location.href.split('#')[0] + '#lost-password');
      });
    },

    /**
     * Handle footer accordion menu
     */
    __footerAccordionMenu: function () {
      wntrTheme.body.on('click', '.bellows-item-level-0 > .bellows-target', function (e) {
        e.preventDefault();
        $(this).find('.bellows-subtoggle').trigger('click');
      });

      wntrTheme.body.find('.bellows-item-level-0 > .bellows-target').attr('tabindex', '-1');
      wntrTheme.body.find('.bellows-item-level-0 > .bellows-target .bellows-subtoggle').attr('tabindex', '-1');
    },

    /**
     * Slider block
     */
    __initSliderBlock: function () {
      const $sliders = wntrTheme.body.find('.slider');
      if ($sliders.length > 0) {
        $sliders.each(function () {
          const $slider = $(this);

          if ($slider.hasClass('slider--small')) {
            $slider.not('.slick-initialized').slick({
              adaptiveHeight: true,
              arrows: true,
              dots: false,
              mobileFirst: true,
              touchThreshold: 20,
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 2,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    centerMode: true,
                    centerPadding: '53px',
                    slidesToShow: 4,
                  },
                },
                {
                  breakpoint: 640,
                  settings: {
                    centerMode: true,
                    centerPadding: '53px',
                    slidesToShow: 3,
                  },
                },
              ],
            });

            if ($(window).width() > 1024) {
              $slider.slick('slickGoTo', $slider.find('.slick-current').next().next().data('slick-index'));
            } else {
              $slider.slick('slickGoTo', $slider.find('.slick-current').next().data('slick-index'));
            }

            setTimeout(() => {
              $slider.removeClass('slider--js-initializing');
            }, 500);
          } else if ($slider.hasClass('slider--large')) {
            $slider.not('.slick-initialized').slick({
              adaptiveHeight: true,
              arrows: true,
              dots: false,
              mobileFirst: true,
              touchThreshold: 20,
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: 1,
              responsive: [
                {
                  breakpoint: 1300,
                  settings: {
                    centerMode: true,
                    centerPadding: '180px',
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 640,
                  settings: {
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 2,
                  },
                },
              ],
            });

            if ($(window).width() >= 626) {
              $slider.slick('slickGoTo', $slider.find('.slick-current').next().data('slick-index'));
            } if ($(window).width() >= 1286) {
              $slider.slick('slickGoTo', $slider.find('.slick-current').next().next().data('slick-index'));
            }

            setTimeout(() => { 
              $slider.removeClass('slider--js-initializing');
            }, 500);
          }
        });
      }
    },

    /**
     * Toggle header menu
     */
    __toggleHeaderMenu: function () {
      wntrTheme.body.find('.header__toggle-menu, .header__overlay').on('click', function () {
        wntrTheme.body.toggleClass('header--active');
      });

      $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
          wntrTheme.body.removeClass('header--active');
        }
      });
    },

    /**
     * Archive endless scroll
     */
    archiveEndlessScroll: function () {
      let throttleTimer = null;
      const throttleDelay = 10;

      function ScrollHandler() {
        clearTimeout(throttleTimer);
        throttleTimer = setTimeout(function () {
          if ($(window).scrollTop() !== $(document).height() - $(window).height()) {
            return;
          }

          if (FWP.settings.pager.page < FWP.settings.pager.total_pages) {
            wntrTheme.body
              .find('.fwp-load-more')
              .html(
                '<img class="spinner" src="' +
                  sliceweekly.get_template_directory_uri +
                  '/src/images/spinner.svg" alt="Laddningsindikator">'
              );
            FWP.paged = parseInt(FWP.settings.pager.page) + 1;
            FWP.is_load_more = true;
            FWP.soft_refresh = false;
            FWP.refresh();
          }
        }, throttleDelay);
      }

      wp.hooks.addFilter('facetwp/template_html', function (resp, params) {
        if (FWP.is_load_more) {
          FWP.is_load_more = false;
          $('.facetwp-template').append(params.html);
          return true;
        }

        return resp;
      });

      $(document).on('facetwp-loaded', function () {
        if (!FWP.loaded) {
          $(window).off('scroll', ScrollHandler).on('scroll', ScrollHandler);
        }
      });
    },

    /**
     *
     */
    __faceWPLoadMoreButton: function () {
      const $spinner = wntrTheme.body.find('.archive__load-more-spinner');
      wntrTheme.body.find('.archive__load-more').on('click', function () {
        const $load_more = $(this);
        $load_more.css('opacity', 0);
        $spinner.css('opacity', 1);
        setTimeout(function () {
          $load_more.css('opacity', 1);
          $spinner.css('opacity', 0);
        }, 1000);
      });
    },

    /**
     * Init handorgel accordions
     */
    __initHandorgelAccordions: function () {
      const $handorgel = wntrTheme.body.find('.handorgel');
      if ($handorgel.length > 0) {
        $.each($handorgel, function () {
          new handorgel($(this)[0]);
        });
      }
    },
  };

  $(document).ready(wntrTheme.init);
})(jQuery);
